    <template>
        <div class="sw-modal edit-form-component">
            <div v-click-outside="cancel" class="sw-modal-content">
                <div class="row sw-modal-heading">
                    <div class="col"><h4><i class="fas fa-image"></i>Edit Appearance</h4></div>
                </div>
                <div class="sw-modal-body">
<!--                    <div class="row question">-->
<!--                        <div class="col-12">-->
<!--                            <h5>CORRESPONDENCE</h5>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row question">-->
<!--                        <label for="correspondence-from-email" class="col-12 question__question">Reply to email:</label>-->
<!--                        <div class="col-12">-->
<!--                            <input v-model="copy.preferences.correspondenceFromEmail" id="correspondence-from-email" type="text" class="short-question">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row question">-->
<!--                        <label for="correspondence-from-name" class="col-12 question__question">Sign off emails as:</label>-->
<!--                        <div class="col-12">-->
<!--                            <input v-model="copy.preferences.correspondenceFromName" id="correspondence-from-name" type="text" class="short-question">-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="row question">
                        <div class="col-12 question__question">
                            What do you call your units?
                        </div>
                        <div class="col-12">
                            <select v-model="copy.preferences.displayCategoryForRoomTypes">
                                <option value="room">Rooms</option>
                                <option value="unit">Units</option>
                                <option value="property">Properties</option>
                            </select>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Use Room Type name instead of Room name?
                        </div>
                        <div class="col-12 text-note">
                            These are names from your Channel Manager / PMS
                        </div>
                        <div class="col-12">
                            <input type="checkbox" v-model="copy.preferences.showRoomTypeNameInsteadOfRoomName" true-value="true" false-value="false"/> Use Room Type name
                        </div>
                    </div>

                    <div class="row question">
                        <label for="email-head-signature" class="col-12 question__question">Email Header & Signature</label>
                        <div class="col-12 text-note">
                            These are added to the beginning and end of emails
                        </div>
                        <div id="email-head-signature" class="col-12">
                            View and edit your <router-link v-bind:to="{ name: 'EditEmailHeaderSignature'}">Email Header & Signature</router-link>
                        </div>
                    </div>

<!--                    <div class="row">-->
<!--                        <div class="col-12 question">-->
<!--                            <h5>COLOURS & IMAGES</h5>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="row question edit-establishment__colours">

                        <div class="col-6">
                            <div class="row">
                                <div class="col-12 question__question">
                                    Primary colour
                                </div>
                                <div class="col-12">
                                    <InputColorPicker v-model="copy.preferences.colourPrimary"/>
<!--                                    <div class="edit-establishment__colours-box" v-bind:style="{'background-color': colourPrimaryHex}"></div>-->
                                    <span>#</span>
                                    <input type="text" maxlength="7" v-model="copy.preferences.colourPrimary" class="short-question">
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12 question__question">
                                    Secondary colour
                                </div>
                                <div class="col-12">
                                    <InputColorPicker v-model="copy.preferences.colourSecondary"/>
<!--                                    <div class="edit-establishment__colours-box" v-bind:style="{'background-color': colourSecondaryHex}"></div>-->
                                    <span>#</span>
                                    <input type="text" maxlength="7" v-model="copy.preferences.colourSecondary" class="short-question">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row question">
                        <div v-if="copy.preferences.images.length > 0" class="col-12 question__question edit-establishment__images-logo-text">
                            Your images
                        </div>
                        <div v-if="copy.preferences.images.length > 0" class="col-12 sw-modal-explanation edit-establishment__images-explanation">
                            <ul>
                                <li>Drag to re-order</li>
                                <li>
                                    The <b>first image</b> is your
                                    <span v-on:mouseenter="showTooltipPrimaryImage = true" v-on:mouseleave="showTooltipPrimaryImage = false" class="what-is-this tooltip-container">
                                        primary image
                                        <tooltip v-bind:visible="showTooltipPrimaryImage" v-bind:position="'bottom'" v-bind:text="'This can be included in communication with Guests, and to easily identify your establishment here in your Host App'"></tooltip>
                                    </span>
<!--                                    (blue border)-->
                                </li>
                                <li>
                                    <b>Click</b> to select your
                                    <span v-on:mouseenter="showTooltipPageHeader = true" v-on:mouseleave="showTooltipPageHeader = false"  class="what-is-this tooltip-container">
                                        page header image
                                        <tooltip v-bind:visible="showTooltipPageHeader" v-bind:position="'bottom'" v-bind:text="'Your page header image is used at the top of forms'"></tooltip>
                                    </span>
<!--                                    (tick)-->
                                </li>
                            </ul>

                        </div>
                        <div class="col-12">
                            <Draggable v-model="copy.preferences.images" group="images" @change="movedImage">
                            <div v-for="(image, index) in copy.preferences.images"
                                 v-bind:key="index"
                                 v-on:click="selectLogo(image.reference)"
                                 class="edit-establishment__images-thumbnail"
                                 v-bind:class="{'edit-establishment__images-thumbnail--selected' : image.reference === copy.preferences.logo,
                                                'edit-establishment__images-thumbnail--primary': index === 0}">
                                <img v-bind:src="image.url"/>
                                <div v-if="index === 0">PRIMARY</div>
                                <div v-if="image.reference === copy.preferences.logo"><i class="fas fa-check"></i></div>
                            </div>
                            </Draggable>
                            <!--                            <i class="fas fa-plus"></i>-->
                        </div>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>
                    <div class="row" v-show="!updating && !success">
                        <div class="col text-center">
                            <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                            <button class="btn btn-primary" v-on:click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

<script>
    import InputColorPicker from 'vue-native-color-picker'
    import Draggable from 'vuedraggable'

    import Spinner from '../Spinner.vue'
    import Tooltip from '../Tooltip'
    // import upload from "../../file-upload.fake.service.js"
    // import wait from "../../wait.js"

    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

    export default {
        name: 'EditEstablishment',
        components: {
            Spinner, Tooltip, InputColorPicker, Draggable
        },
        props: {
            establishment: Object
        },
        data: function() {
            return {
                copy: {
                    preferences: {
                        correspondenceFromName: "",
                        correspondenceFromEmail: "",
                        displayCategoryForRoomTypes: "room",
                        colourPrimary: "",
                        colourSecondary: "",
                        images: [],
                        logo: null,
                    }
                },
                uploadError: null,
                currentStatus: null,
                updating: false,
                error: false,
                success: false,
                infoMessage: "",
                uploadFieldName: 'files',
                showTooltipPrimaryImage: false,
                showTooltipPageHeader: false
            }
        },
        computed: {
          isInitial() {
              return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
              return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
              return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
              return this.currentStatus === STATUS_FAILED;
          }
        },
        methods: {
            reset: function() {
                // reset form to initial state
                this.currentStatus = STATUS_INITIAL;
                this.infoMessage = null;
            },
            selectLogo: function(imageReference) {
                if (this.copy.preferences.logo === imageReference) {
                    this.copy.preferences.logo = null;
                } else {
                    this.copy.preferences.logo = imageReference;
                }
            },
            movedImage: function(event) {
                this.error = false;
                console.log(event);
                if (event.moved) {
                    console.log("Change ordering...");
                    let body = {
                        reference: event.moved.element.reference,
                        index: event.moved.newIndex
                    };
                    this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference + '/images/move-image', body
                    ).then(() => {
                        this.establishment.preferences.images.splice(event.moved.oldIndex, 1);
                        this.establishment.preferences.images.splice(event.moved.newIndex, 0, event.moved.element);
                    }).catch(error => {
                        this.copy.preferences.images.splice(event.moved.newIndex, 1);
                        this.copy.preferences.images.splice(event.moved.oldIndex, 0, event.moved.element);
                        this.error = true;
                        if (error.response) {
                            this.infoMessage = error.response.data.message
                        } else {
                            this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    });
                    console.log("Moved image...");
                }
            },
            cancel: function() {
                console.log("cancel");
                this.establishment.name = this.copy.name;
                this.$root.$emit('finished-editing-establishment-appearance');
            },
            save: function() {
                console.log("saving establishment");
                this.error = false;

                let body = {
                    "reference": this.copy.reference,
                    "preferences": {
                        "displayCategoryForRoomTypes": this.copy.preferences.displayCategoryForRoomTypes,
                        "showRoomTypeNameInsteadOfRoomName": this.copy.preferences.showRoomTypeNameInsteadOfRoomName,
                        "colourPrimary": this.copy.preferences.colourPrimary,
                        "colourSecondary": this.copy.preferences.colourSecondary,
                        "correspondenceFromName": this.copy.preferences.correspondenceFromName,
                        "correspondenceFromEmail": this.copy.preferences.correspondenceFromEmail,
                        "logo": this.copy.preferences.logo,
                        // this is here, so that we don't remove it by leaving it null
                        "frontDeskBackgroundImage": this.copy.preferences.frontDeskBackgroundImage,
                    }
                }

                // updating a form template
                this.updating = true;
                this.infoMessage = "Saving establishment";
                this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference, body
                ).then(() => {
                    this.infoMessage = "Establishment updated";
                    this.success = true;
                    Object.assign(this.establishment, this.copy);
                    setTimeout(() => {
                        this.updating = false;
                        this.$root.$emit('finished-editing-establishment-appearance');
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.updating = false;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message
                    } else {
                        this.infoMessage = "Error updating establishment";
                    }
                });
            }
        },
        mounted() {
            this.reset();
            this.copy = { ...this.establishment };
            this.copy.preferences = { ...this.establishment.preferences };
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_establishment";
    @import "../../styles/components/question_answer";
</style>